import { styled, theme, utils } from 'ui/theme';

import { ProductCard } from '../Product';

export const PointsProgram = {
  ItemsCampaign: {
    Card: styled(ProductCard.Card)`
      display: block;
    `,

    Wrapper: styled('div')`
      /* margin: 0 ${theme.space[2]} ${theme.space[4]} ${theme.space[2]}; */
      padding: 0 calc(-1 * ${theme.space[4]}) 0 calc(-1 * ${theme.space[4]});
      overflow: hidden;

      ${utils.media.min('m')`
        margin: 0;
        padding: 0 0 0 ${theme.space[8]};
        position: relative;
      `}
    `,
  },
};
